import i18n from "i18n";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useWidgetSummaryAvailability from "ai/hooks/useWidgetSummaryAvailability";
const useWidgetSummaryUnavailableReason = (widgetType) => {
  var _a;
  const { data: availability, isLoading: loadingAvailability } = useWidgetSummaryAvailability(widgetType);
  const { data: aiConfig, isLoading: loadingAIConfig } = useAIConfiguration();
  if (loadingAIConfig || (aiConfig == null ? void 0 : aiConfig.isEnabled) !== true) {
    return i18n.t("common_texts.ai_disabled", { ns: "enterprise_ai" });
  }
  if (loadingAvailability) {
    return i18n.t("widget_summary_unavailable.checking", { ns: "enterprise_ai" });
  }
  if (!availability.available) {
    return (_a = availability.message) != null ? _a : i18n.t("widget_summary_unavailable.not_available", { ns: "enterprise_ai" });
  }
  return void 0;
};
export default useWidgetSummaryUnavailableReason;
